import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryDetailsCard`

export default defineMessages({
  currentBudgetPeriodOptionSuffix: {
    id: `${scope}.currentBudgetPeriodOptionSuffix`,
    defaultMessage: ' (Current)',
  },
})
